import { hashCodeLib, dateUtils } from 'shared';

export type CabinClassKey = 'economy' | 'business' | 'youth';

export type FavoriteSearchMeta = {
  dateLine: string;
  passengerTotal: number;
  cabinClassKey: CabinClassKey;
};

function getCabinClassKey(cabinClass: string, isYouth: boolean): CabinClassKey {
  if (cabinClass === 'B') return 'business';
  if (isYouth) return 'youth';
  return 'economy';
}

export function getFavoriteSearchMeta(
  searchQuery: string,
): FavoriteSearchMeta | null {
  try {
    const searchParams = hashCodeLib.getSearchParams(searchQuery);
    const dates = searchParams.dates.map(rawDate =>
      dateUtils.getVerbalDate(rawDate),
    );
    const dateLine =
      dates.length >= 2
        ? `${dates[0] ?? ''} — ${dates[1] ?? ''}`
        : (dates[0] ?? '');
    const passengerTotal =
      searchParams.passengers.adt +
      searchParams.passengers.chd +
      searchParams.passengers.inf +
      searchParams.passengers.yth;
    const cabinClassKey = getCabinClassKey(
      searchParams.cabinClass,
      searchParams.isYouth,
    );

    return { dateLine, passengerTotal, cabinClassKey };
  } catch {
    return null;
  }
}
